import { CheckoutTab } from "pages/checkout/providers/CheckoutTabsProvider";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

export enum ProgressBarItemStatus {
  ACTIVE,
  VISITED,
  UPCOMING,
}

interface CheckoutProgressBarItemProps {
  tab: CheckoutTab;
  id: number;
  onClick: () => void;
  status: ProgressBarItemStatus;
  isDividerActive: boolean;
}

const CheckoutProgressBarItem = ({
  tab,
  id,
  onClick,
  status,
  isDividerActive,
}: CheckoutProgressBarItemProps) => {
  return (
    <div
      className={concatClassnames(
        (status === ProgressBarItemStatus.ACTIVE ||
          status === ProgressBarItemStatus.VISITED) &&
          "gg-cursor-pointer",
        "gg-w-full gg-text-left gg-relative gg-pt-6",
        "gg-relative gg-z-10",
        "after:-gg-z-10 after:gg-w-full after:gg-absolute after:gg-top-[30px]",
        "after:gg-left-0 after:gg-right-0 after:gg-h-0.5",
        isDividerActive ? "after:gg-bg-dark-blue" : "after:gg-bg-gray-300"
      )}
      onClick={() => onClick()}
      key={tab.title}
    >
      {status === ProgressBarItemStatus.ACTIVE ? (
        <Text
          className="gg-absolute gg-bg-yellow gg-w-full gg-px-1.5 sm:gg-w-fit sm:gg-text-base md:gg-px-2.5 gg-py-1
            -gg-rotate-6 -gg-translate-y-1/2 gg-text-xs gg-overflow-auto"
          bold
        >
          Jij bent hier
        </Text>
      ) : (
        <></>
      )}

      <span
        className={concatClassnames(
          "gg-block gg-w-3.5 gg-h-3.5",
          "gg-rounded-full gg-mb-3 gg-z-10",
          status === ProgressBarItemStatus.VISITED
            ? "gg-bg-dark-blue"
            : "gg-border-2 gg-border-gray-300 gg-bg-white"
        )}
      ></span>

      <Heading headingLevel="h6" className="gg-font-bold gg-text-dark-blue-300">
        {`Stap ${id + 1}`}
      </Heading>

      <Text
        className="lg:gg-hidden gg-flex gg-flex-col gg-break-words sm:gg-w-7/12 md:gg-w-9/12"
        bold
      >
        {tab.displayOne ? (
          <>
            <span>{tab.displayOne}</span>
            <span>{tab.displaySecond}</span>
          </>
        ) : (
          tab.title
        )}
      </Text>

      <Text
        className="gg-hidden lg:gg-flex gg-flex-col gg-break-words sm:gg-w-7/12 md:gg-w-9/12"
        bold
      >
        {tab.title}
      </Text>
    </div>
  );
};
export default CheckoutProgressBarItem;
